import { PlayerState, User } from "module/types";

class UserSession {
  private static instance: UserSession;
  public static getInstance(): UserSession {
    if (!UserSession.instance) {
      UserSession.instance = new UserSession();
    }
    return UserSession.instance;
  }
  private _user: User = {
    socketId: "",
    nickName: "",
    defaultNickName: "",
    id: -1,
    isHost: false,
    state: PlayerState.DISCONNECTED,
    isAI: false,
  };

  private constructor() {
    // Initialize
    let random = Math.floor(Math.random() * 9999);
    this._user.defaultNickName = "Player_" + random;
  }

  public get user(): User {
    return this._user;
  }

  public changeNickName(nickName: string): void {
    this._user.nickName = nickName;
  }

  // if nickName is empty, return default NickName
  public getUserNickName(): string {
    if (this._user.nickName === "") {
      return this._user.defaultNickName;
    }
    return this._user.nickName;
  }

  public setUserId(id: number) {
    this.user.id = id;
  }

  public getUserId() {
    return this._user.id;
  }
  public setHost(isHost: boolean) {
    this.user.isHost = isHost;
  }
}

export default UserSession;
